import React from 'react';
import { Provider } from 'react-redux';
import { Link } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import { hot } from 'react-hot-loader/root';
import { History } from 'history';
import { Divider, Layout, Space, Typography } from 'antd';

import { Store } from '../store';
import Routes from '../Routes';
import routes from '../constants/routes.json';

const { Header, Content, Footer } = Layout;
const { Text, Title } = Typography;

type Props = {
  store: Store;
  history: History;
};

const Root = ({ store, history }: Props) => (
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Layout>
        <Header className="headerContainer">
          <Title id="headerTitle" level={3}>
            My BTC Stats
          </Title>
        </Header>
        <Content>
          <Routes />
        </Content>
        <Footer className="footer">
          <Space>
            <Link to={routes.HOME}>Home</Link>
            <Divider type="vertical" />
            <Link to={routes.WORKFLOW}>Get Started</Link>
            <Divider type="vertical" />
            <Link to={routes.PRIVACY}>Privacy Policy</Link>
            <Divider type="vertical" />
            <Text>Send questions or comments to hello@bryanmillstein.com</Text>
          </Space>
        </Footer>
      </Layout>
    </ConnectedRouter>
  </Provider>
);

export default hot(Root);
